import { Appointment } from ".";

/**
 * The appointment state is a flags enum representing multiple states
 */
export enum AppointmentState
{
    Initial   = 0,       // 00000000 // Appointment has been created
    Offered   = 1 << 0,  // 00000001 // Appointment created by offer from the dealership - no date at this point
    Booked    = 1 << 1,  // 00000010 // Appointment created by consumer at checkout
    Declined  = 1 << 2,  // 00000100 // Declined by the consumer
    Missed    = 1 << 3,  // 00001000 // Consumer missed the appointment, no-show
    Completed = 1 << 4,  // 00010000 // Consumer attended the appointment
    Cancelled = 1 << 5,  // 00100000 // Cancelled by the consumer or dealership
    Closed    = 1 << 6   // 01000000 // Closed, dont show it in the list
};

export namespace AppointmentState
{
    export function toString( stateOrAppointment: AppointmentState | Appointment )
    {

        const state = stateOrAppointment instanceof Appointment ? stateOrAppointment.appointmentState : stateOrAppointment;
        const appointment = stateOrAppointment instanceof Appointment ? stateOrAppointment : null;

        // Consumer has been offered an appointment which they havent confirmed or declined
        if( state < AppointmentState.Booked ) return 'Offered';

        // Closed - these should not be shown in the UI
        if( ( state & AppointmentState.Closed ) === AppointmentState.Closed ) return 'Closed';
        
        // The appointment was declined by the Consumer but hasnt yet been closed 
        // (closed must be handled higher up this function)
        if( state & AppointmentState.Declined ) return 'Declined by customer';

        // The appointment was booked and the appointment date is now in the past, but the
        // appointment has not been marked completed or cancelled
        // NOTE: This state requires an appointment to be passed in
        if( state < AppointmentState.Missed
            && appointment != null && appointment.utcDateAppointment != null
            && new Date( appointment.utcDateAppointment ) < new Date() ) return 'Pending';

        // The appointment was missed by the consumer but hasnt yet been closed
        // (closed must be handled higher up this function)
        if( ( state & AppointmentState.Missed ) === AppointmentState.Missed ) return 'No show';

        // The appointment has been marked as completed
        if( ( state & AppointmentState.Completed ) === AppointmentState.Completed ) return 'Completed';

        // The appointment has been marked as cancelled
        if( ( state & AppointmentState.Cancelled ) === AppointmentState.Cancelled ) return 'Cancelled';

        // The appointment is booked and in the future
        if( ( state & AppointmentState.Booked ) === AppointmentState.Booked ) return 'Booked';

        return 'Pending'; 
    }
}

